'use strict';

import PropTypes from 'prop-types';
import React, { Component } from 'react';

// redux
import { connectWithStore } from 'appState';
import { bindActionCreators } from 'redux';
import {
	// batch stuff
	addBatchList,
	updateBatchForm,
	removeBatchListItem,

	// regular stuff
	setProductVariantTranslation,
	updateProductVariantTranslation,
	resetState,
	editBatchListItem,
} from './store/productVariantTranslations.actions';

// services
import {
	fetchProductVariantTranslations,
	addProductVariantTranslations,
	deleteProductVariantTranslations,
	editProductVariantTranslation,
	editProductVariantTranslations,
} from './productVariantTranslations.service';

// components
import { ReactDataWrapper } from 'reactDataWrapper';
import { Button, Icon, Input } from 'dumb';
import ProductVariantTranslationsModalBatch from './components/batch/productVariantTranslationsModalBatch';
// same columns as for product/ingredient_translations
import getProductTranslationsColumns from 'reactDataWrapperColumns/product/productTranslations.columns';

// utils
import moment from 'moment';
import phrases from './productVariantTranslations.phrases';
import { getEditedValues } from 'services/utils';

const reduxKey = '/product/product_variant_translations';

class IngredientTranslations extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showModal: false,
			key: moment().unix(),
		};

		this.deleteEntry = this.deleteEntry.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.addProductVariantTranslationsWrapper = this.addProductVariantTranslationsWrapper.bind(this);
		this.fetchData = this.fetchData.bind(this);
		this.editEntry = this.editEntry.bind(this);
		this.editMultiple = this.editMultiple.bind(this);
		this.setInitialEditValues = this.setInitialEditValues.bind(this);
		this.editStoreEntry = this.editStoreEntry.bind(this);

		this.columns = getProductTranslationsColumns();
	}

	deleteEntry(id) {
		return deleteProductVariantTranslations(id);
	}

	editEntry(data) {
		const { productVariantTranslation, originalProductVariantTranslation } = this.props;

		const editedValues = getEditedValues({
			oldData: originalProductVariantTranslation,
			newData: productVariantTranslation,
		});

		const payload = data || {
			id: productVariantTranslation.id,
			name: editedValues.name ?? undefined,
			description: editedValues.description ?? undefined,
		};

		return editProductVariantTranslation(payload);
	}

	editMultiple(selectedRows) {
		const { productVariantTranslation } = this.props;

		const payload = {
			...(productVariantTranslation.name && {
				name: productVariantTranslation.name,
			}),
			...(productVariantTranslation.description && {
				description: productVariantTranslation.description,
			}),
		};

		const selectedRowsWithId = selectedRows.map((row) => {
			return {
				id: row.id,
				...payload,
			};
		});

		return editProductVariantTranslations({
			batch: selectedRowsWithId,
		});
	}

	setInitialEditValues(data) {
		const payload = {
			id: data.id,
			language: data.language?.name ?? '',
			name: data.name,
			description: data.description,
		};

		this.props.setProductVariantTranslation(payload);
	}

	getEditableCells() {
		const { productVariantTranslation } = this.props;

		return [
			{
				header: 'Language',
				value: <span>{productVariantTranslation.language}</span>,
			},
			{
				header: 'Name',
				value: (
					<Input
						id="name"
						placeholder="Enter name..."
						value={productVariantTranslation?.name ?? ''}
						onChange={(e) => this.editStoreEntry(e.target.value, 'name')}
					/>
				),
			},
			{
				header: 'Description',
				value: (
					<Input
						id="description"
						placeholder="Enter description..."
						value={productVariantTranslation?.description ?? ''}
						onChange={(e) => this.editStoreEntry(e.target.value, 'description')}
					/>
				),
			},
		];
	}

	editStoreEntry(e, type) {
		this.props.updateProductVariantTranslation({
			[type]: e,
		});
	}

	fetchData(state) {
		const { productVariant } = this.props;

		const filter = `:product_variant.id=='${productVariant.id}'`;

		return fetchProductVariantTranslations(state, filter);
	}

	toggleModal() {
		this.setState((prevState) => ({ showModal: !prevState.showModal }));
		this.props.resetState();
	}

	addProductVariantTranslationsWrapper(data) {
		return addProductVariantTranslations(data).then(() =>
			this.setState(() => ({
				key: moment().unix(),
			}))
		);
	}

	render() {
		const {
			batchList,
			removeBatchListItem,
			addBatchList,
			batchForm,
			updateBatchForm,
			productVariant,
			editBatchListItem,
		} = this.props;

		return (
			<>
				<ReactDataWrapper
					accessAreasAllowedToEdit={['Sales Configuration']}
					key={this.state.key}
					title={phrases.TITLE}
					columns={this.columns}
					fetchData={this.fetchData}
					filterable
					defaultPageSize={10}
					reduxKey={`${reduxKey}-${productVariant.id}`}
					manual
					editEntry={this.editEntry}
					editMultiple={this.editMultiple}
					editableCells={this.getEditableCells()}
					setInitialEditValues={this.setInitialEditValues}
					deleteEntry={this.deleteEntry}
					onModalClose={this.props.resetState}
					actionRender={
						<Button type="inverted" label="Batch" shadow onClick={this.toggleModal}>
							<Icon name="add" />
						</Button>
					}
				/>

				<ProductVariantTranslationsModalBatch
					modalVisible={this.state.showModal}
					handleClose={this.toggleModal}
					batchList={batchList}
					batchForm={batchForm}
					removeBatchListItem={removeBatchListItem}
					addBatchList={addBatchList}
					addProductVariantTranslations={this.addProductVariantTranslationsWrapper}
					updateBatchForm={updateBatchForm}
					productVariant={productVariant}
					editBatchListItem={editBatchListItem}
				/>
			</>
		);
	}
}

IngredientTranslations.propTypes = {
	resetState: PropTypes.func,
	batchList: PropTypes.array,
	removeBatchListItem: PropTypes.func,
	batchForm: PropTypes.object,
	addBatchList: PropTypes.func,
	updateBatchForm: PropTypes.func,
	productVariant: PropTypes.object,
	setProductVariantTranslation: PropTypes.func,
	updateProductVariantTranslation: PropTypes.func,
	productVariantTranslation: PropTypes.object,
	originalProductVariantTranslation: PropTypes.object,
	editBatchListItem: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			updateBatchForm,
			removeBatchListItem,
			resetState,
			addBatchList,
			setProductVariantTranslation,
			updateProductVariantTranslation,
			editBatchListItem,
		},
		dispatch
	);
};

const mapStateToProps = (store) => {
	return {
		productVariantTranslation: store.productVariantTranslations.data.productVariantTranslation,
		originalProductVariantTranslation: store.productVariantTranslations.data.originalProductVariantTranslation,
		batchList: store.productVariantTranslations.data.batchList,
		batchForm: store.productVariantTranslations.data.batchForm,
	};
};

export default connectWithStore(IngredientTranslations, mapStateToProps, mapDispatchToProps);
